// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"43aa8e48","221":"eb804a72","239":"c939f4ee","244":"a3f2e637","395":"007e3ba8","433":"49dc5c94","453":"01f016a2","732":"8b751c54","935":"87ca0c79","977":"98e57384"}[chunkId] + ".chunk.js";
};